export const environment = {
    production: false,
    domain: 'https://dev-web.scanafy.de',
    apiUrl: 'https://dev-api.scanafy.de/api',
    apiAuthUrl: 'https://dev-api.scanafy.de/api/auth',
    appRegistrationUrl: 'https://dev.scanafy.de/register',
    productVideoVimeoUrl: 'https://vimeo.com/1209316119?share=copy&fl=sv&fe=ci'
};
